import React from 'react';
import { Task } from '../../../../../types/task';
import { TaskProjectInfo } from './index';

interface TaskTitleProps {
  task: Task;
  hideProjectName?: boolean;
  onProjectClick?: (projectId: string) => void;
  t: (key: string) => string;
  titleClassName: string; // 'text-ios-body truncate' vs 'text-ios-body font-medium truncate'
  titleColorClass: string; // 简单完成状态 vs 精致颜色控制
}

/**
 * 任务标题组件
 * 统一TaskItem和FocusTaskItem的标题显示
 */
export const TaskTitle: React.FC<TaskTitleProps> = ({
  task,
  hideProjectName = false,
  onProjectClick,
  t,
  titleClassName,
  titleColorClass
}) => {
  // 构建完整的标题样式类
  const fullTitleClassName = `${titleClassName} ${
    task.done 
      ? 'line-through text-ios-gray2 dark:text-ios-dark-gray2' 
      : titleColorClass
  }`;

  return (
    <div className="flex items-center justify-between">
      <div className={fullTitleClassName}>
        {task.title}
      </div>

      {/* 项目信息始终显示在标题行右侧 */}
      <TaskProjectInfo
        task={task}
        hideProjectName={hideProjectName}
        onProjectClick={onProjectClick}
        t={t}
      />
    </div>
  );
};
